module.exports = __webpack_public_path__ + "static/media/ic_invest_save_tax.43ba8cdf.svg";